const config: App.AppConfig = ((global as any).__STATIC_CONFIG__ ?? {})

export function setConfig(newConfig: Partial<App.AppConfig>) {
  Object.assign(config, newConfig)
  return config
}

export default config
